/*eslint-disable */
import { Dialog } from "@material-ui/core";
import React, { FunctionComponent, useEffect, useMemo,useState } from "react";
import { formatNumber, purposeCodeList } from "../../utils";
import { IAmount } from "./Amount";
import Button from "../../components/ui/Button";
import { Mixpanel } from "../../constants/mixpanel";
import { useRecoilState } from "recoil";
import { panDeclaration, selectedPurpose } from "../../store";
import { CloseIcon } from "../../assets/Icons";
import RoundCloseIcon from "../../assets/Icons/RoundCloseIcon";
import { set } from "cypress/types/lodash";

export const Modals: FunctionComponent<IAmount.ModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  receivingCountryModalData,
  setDestCurrency,
  // setPurposeCode,
  // setPurposeValue,
  setPan,
  setIsEducation,
  // sendTransferSummary,
  sendingAmount,
  destCurrency,
  errorMessage,
  isPurposeModalOpen,
  setIsPurposeModalOpen,
  isPanModelOpen,
  setIsPanModelOpen,
  tcs,
  setDeclareAmount,
  moneySendViaMoneyhop,
  enableDecalreAmount,
  modalLoading,
  setEnableDeclareAmount,
  setFirstTimeLoanPopup,
  firstTimeLoanPopup,
  declareAmount,
  setTcs,
  tempPan,
  setTempPan
}) => {
  const [panDeclarationValue, setPanDeclarationValue] = useRecoilState(panDeclaration);
  const [, setPurposeCode] = useRecoilState(selectedPurpose)
  const [showLoading, setShowLoading] = useState(false);

  const handleClearInput = () => {
    setPanDeclarationValue("");
    setPan("")
  };

  useEffect(() => {
    const storedAmount = localStorage.getItem('declareAmount');
    if (storedAmount) {
      if (setDeclareAmount) {
        setDeclareAmount(storedAmount);
      }
    }
  }, []);

  useEffect(() => {
  if (panDeclarationValue?.length !== 10 || !!errorMessage) {
    if (setDeclareAmount) {
    setDeclareAmount(0);
    }
    localStorage.removeItem("declareAmount");
  }
}, [panDeclarationValue, errorMessage]);


  // Update localStorage whenever declareAmount changes
  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (panDeclarationValue?.length === 10 && !errorMessage) {
      if (setDeclareAmount) {
      setDeclareAmount(value);
      }
      localStorage.setItem("declareAmount", value);
    }
  };



  const handleClearAmountInput = () => {
    if (setDeclareAmount) {
    setDeclareAmount(""); // Clear declareAmount
    }
    localStorage.removeItem('declareAmount'); // Remove from localStorage
  };



  const buttonTitle = useMemo(() => {
    return enableDecalreAmount ? "Submit" : "Proceed";
  }, [enableDecalreAmount]);

  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";


  return (
    <div>
      <Dialog open={isModalOpen === "recieve"} onClose={() => setIsModalOpen("")}>
        <div className="px-8 py-3 font-bold text-white bg-primary">Select Destination Currency</div>
        <div className="pt-4 px-7 lg:px-9">
          <div className="h-12 lg:border-none w-[372px] lg:w-[404px] mb-9"></div>
          <div className="lg:mx-[68px] -mt-20">
            {receivingCountryModalData && receivingCountryModalData.map((data, index) => {
              return (
                <div
                  className="flex items-center justify-between w-full py-6 border-b cursor-pointer lg:mb-9 lg:border-none lg:py-3 border-grey-1000"
                  key={index}
                  onClick={() => {
                    setIsModalOpen("");
                    setDestCurrency(data.currencyName);
                    // sendTransferSummary && sendTransferSummary(sendingAmount, data.currencyName, true);
                  }}
                >
                  <div className="mr-8 text-xl font-normal text-primary-650">
                    {data.currencyName}
                  </div>
                  <div className="flex items-center w-2/6">
                    <div className="flex items-center justify-center w-8 h-8 mr-5">
                      <img
                        src={`/images/png/${data.currencyName}.png`}
                        alt="country-image"
                        className="rounded-[200px] w-full h-full"
                      />
                    </div>
                    < div className="text-xl font-bold text-left text-primary-650 justify-items-start">
                      {data.currencyName}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>

      <Dialog open={isPurposeModalOpen} onClose={() => setIsPurposeModalOpen(false)}>
        <div className="px-8 py-3 font-bold text-white bg-primary">Select Purpose Code</div>
        {purposeCodeList.map((el) => (
          <div
            key={el.code}
            onClick={() => {
              setPurposeCode({ purposeCode: el.code, purposeValue: el.value });
              setIsPurposeModalOpen(false);
              if (el.value === "Family Maintenance" || el.value === "Personal Gift or Donation") {
                // setFirstTimeLoanPopup(true);
                setIsEducation(false)
              } else {
                setIsModalOpen("loan");
                setFirstTimeLoanPopup(false);
              }
              // if (el.code === "S0305" && tcs !== 0) {
              //   // setIsModalOpen("loan");
              // } else {
              //   setIsEducation(false);
              // }
            }}
            className="px-3 py-2 mx-3 my-2 border rounded cursor-pointer hover:bg-gray-200"
          >
            {el.value}
          </div>
        ))}
      </Dialog>

      <Dialog open={isPanModelOpen}>
        <div className="border rounded-lg overflow-hidden">
          <div className="flex flex-row justify-between items-center px-5 pt-2">
            <div className="font-bold text-[22px] text-center text-primary-1050">TCS Declaration</div>
            <CloseIcon className="cursor-pointer" onClick={() =>
            {
              setIsPanModelOpen(false)
              if(errorMessage){
                setTempPan("");
                setPanDeclarationValue("");
              }
            }
               } />
          </div>
          <div className="flex flex-col items-left px-6 w-[500px]">
            <span className="font-medium text-[18px] mt-2">PAN</span>
            <input
              className={`p-2 w-full border  rounded-lg ${errorMessage ?"border-red-100":"border-gray-400"}`}
              type="text"
              value={tempPan}
              onChange={(e) => setTempPan(e.target.value.toUpperCase())}
              autoComplete="off"
              maxLength={10}
              pattern={specialCharRegExp}
            />
            {tempPan && (
              <span
                className="relative bottom-5 left-[21rem] -translate-y-1/2 cursor-pointer"
                onClick={() => {
                  setTempPan("");
                  setPanDeclarationValue("");
                  setPan("");
                }}
              >
                <RoundCloseIcon />
              </span>
            )}
            <button
              type="button"
              onClick={() => 
              {
                  setPanDeclarationValue(tempPan);
                  setShowLoading(true)
                  setTimeout(() => {
                    setShowLoading(false);
                  }, 300);
              }
              }
              className={`w-fit relative -translate-y-1/2 px-4 py-1 bg-green-500 text-white rounded-lg outline-none ${tempPan?.length !== 10 || !tempPan?.match(specialCharRegExp) ? "opacity-50 cursor-not-allowed" : "opacity-100 cursor-pointer"} ${tempPan ? "bottom-[2.8rem] left-[23rem]":"bottom-[1.3rem] left-[23rem]" }`}
              disabled={tempPan?.length !== 10 || !tempPan?.match(specialCharRegExp)}
            >
              {showLoading ? <div className="animate-spin rounded-full border-4 border-t-4 border-white h-6 w-6"></div> : "Check"}
            </button>
            {/* {errorMessage && <span className="text-red-100 -mt-2 my-3">{errorMessage}</span>} */}
            {moneySendViaMoneyhop !== undefined  && panDeclarationValue?.length === 10 && !errorMessage && (
              <span className="font-normal relative bottom-10 text-justify text-[16px]">
              Transactions amounting to ₹{formatNumber(moneySendViaMoneyhop)} have already been made by this PAN card holder in the current financial year.
              </span>
            )}
            {enableDecalreAmount && (
              <div className="flex flex-col items-left -mt-6">
                <span className="font-medium text-[18px]">Enter Amount</span>
                <span className="font-normal text-[14px]">
                  If you have done any other transaction please enter the amount in INR
                </span>
                <input
                  className="p-2 w-full mt-2 border border-gray-400 rounded-lg"
                  type="number"
                  onChange={handleAmountChange}
                  autoComplete="off"
                  value={declareAmount?.toLocaleString("en-IN")}
                  disabled={panDeclarationValue?.length !== 10}
                />
              {panDeclarationValue?.length === 10 && declareAmount ? (
                <span
                  className="relative bottom-[1.2rem] left-[26rem] -translate-y-1/2 cursor-pointer"
                  onClick={handleClearAmountInput}
                >
                  <RoundCloseIcon />
                </span>
              ) : null}
              </div>
            )}
            <div className="flex flex-row py-5 justify-center">
              <Button
                className={`px-6 py-3 border rounded-lg w-[50%] text-white-100 ${!panDeclarationValue || panDeclarationValue?.length !== 10 || errorMessage ||
                (typeof declareAmount === "string" && declareAmount === "") ||
                isNaN(Number(declareAmount)) ? "opacity-15": "opacity-100" }`}
                isLoading={modalLoading}
                onClickHandler={() => {
                  // sendTransferSummary(sendingAmount, destCurrency, false, false);
                  Mixpanel.track("PAN_based");
                    if (buttonTitle === "Submit" && !errorMessage) {
                      setIsPanModelOpen(false);
                      setEnableDeclareAmount(false);
                    }
                }}
              disabled={
                !panDeclarationValue || panDeclarationValue?.length !== 10 ||
                (typeof declareAmount === "string" && declareAmount === "") ||
                isNaN(Number(declareAmount)) || errorMessage
              }
              >
                {buttonTitle}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
      {/*change in loan popup  */}
      <Dialog
        open={firstTimeLoanPopup === false && isModalOpen === "loan"}
      >
        <div className="flex flex-col items-center text-center p-4 w-[450px] rounded-lg">
        <div className="flex flex-row justify-between items-center w-full pb-3">
          <div className="font-bold text-[22px] text-center text-primary-1050 ml-[27%]">Loan Confirmation</div>
            <CloseIcon className="cursor-pointer" onClick={() => setIsModalOpen("")} />
          </div>
          <span className="font-semibold text-[14px]">
            Do you have a valid education loan disbursement letter?
          </span>
          <span className="font-normal text-[14px]">
            If yes, your TCS will be 0%. You will be asked to upload a digital copy of the loan disbursement letter.
          </span>
          <div className="flex mt-5 space-x-5">
            <button
              className="px-6 py-1 border border-transparent bg-green-500 rounded-lg text-white-200"
              onClick={() => {
                setIsEducation(true);
                // setIsModalOpen("");
                setFirstTimeLoanPopup(true);
                setIsModalOpen("");
                setTcs(0)
              }}
            >
              Yes
            </button>
            <button
              className="px-6 py-1 border border-transparent bg-red-100 rounded-lg text-white-200"
              onClick={() => {
                setIsEducation(false);
                setIsModalOpen("");
                setFirstTimeLoanPopup(true);
                // setIsModalOpen("");
              }}
            >
              No
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
